import React from "react";

import { Container } from "./styles";

function EN() {
  return (
    <Container id="en">
      <iframe
        src={process.env.REACT_APP_EN_DESKTOP}
        id="desktop-en"
        className="responsive-iframe-desktop"
        title="Importacao_Vinhos_Demonstracao"
        width="600"
        height="373.5"
        frameborder="0"
        allowfullscreen="true"
      />
      <iframe
        src={process.env.REACT_APP_EN_MOBILE}
        id="mobile-en"
        className="responsive-iframe-mobile"
        title="teste layout vertical"
        width="600"
        height="373.5"
        frameborder="0"
        allowfullscreen="true"
      />
    </Container>
  );
}

export default EN;
